import React from 'react';
import { RouterItems } from './routing';
import { ThemeProvider } from '@mui/material/styles';
import './index.css';
import { customTheme } from './styles/customTheme/index';
import { LoadingScreen } from './components/preAuthentification/LoadingScreen';
import { useDataInitialization } from './hooks/useDataInitialization';
import { ContactSystemAdminScreen } from './components/preAuthentification/ContactSystemAdminScreen';
import { SnackbarProvider } from 'notistack';
import { useIsAuthenticated } from '@azure/msal-react';
import { PageLogin } from './pages/pageLogin';

function App(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { isLoading, isError } = useDataInitialization();

  if (!isAuthenticated) {
    return (
      <ThemeProvider theme={customTheme}>
        <PageLogin />
      </ThemeProvider>
    );
  }

  if (isLoading ) {
    return (
      <ThemeProvider theme={customTheme}>
        {isLoading ? <LoadingScreen /> : <ContactSystemAdminScreen />}
      </ThemeProvider>
    );
  }
  

  return (
    <ThemeProvider theme={customTheme}>
      <SnackbarProvider maxSnack={4}>
        <RouterItems />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
